import { AuthError } from '@supabase/supabase-js';

/**
 * Extended auth error with additional fields that Supabase may return
 */
export interface ExtendedAuthError {
  message: string;
  name?: string;
  status?: number;
  error_code?: string;
  code?: string;
  __isAuthError?: boolean;
}

/**
 * Result type for auth operations
 */
export interface AuthResult {
  error: AuthError | ExtendedAuthError | Error | null;
}

/**
 * Supabase error structure for parsing
 */
export interface SupabaseErrorLike {
  message?: string;
  error_code?: string;
  status?: number;
  code?: string;
  name?: string;
}

/**
 * Type guard to check if an error is a SupabaseErrorLike
 */
export function isSupabaseError(error: unknown): error is SupabaseErrorLike {
  return (
    typeof error === 'object' &&
    error !== null &&
    ('message' in error || 'error_code' in error || 'status' in error)
  );
}

/**
 * Safely extract error message from unknown error type
 */
export function getErrorMessage(error: unknown): string {
  if (typeof error === 'string') return error;
  if (error instanceof Error) return error.message;
  if (isSupabaseError(error)) return error.message || 'Erro desconhecido';
  return 'Erro desconhecido';
}
